/* eslint-disable no-console */
import { ErrorLogger, HttpError, LogLevel } from '@ideals/services/error-logger';

const LOG_METHODS: Record<LogLevel, (...args: unknown[]) => void> = {
  error: console.error,
  warn: console.warn,
  info: console.info,
  debug: console.debug,
};

export class ConsoleErrorLogger implements ErrorLogger {
  available(): boolean {
    return true;
  }

  logHttpError(error: HttpError): Promise<void> {
    console.error(error);

    return Promise.resolve();
  }

  logJsError(error: Error, exception: string, level: LogLevel): Promise<void> {
    LOG_METHODS[level](error, exception);

    return Promise.resolve();
  }
}
